import ToastComponent from '@/components/unifiedErrorMessage.vue'

const Toast = {}

Toast.install = function (Vue) {
  const ToastConstructor = Vue.extend(ToastComponent)
  // 生成该子类实例
  const instance = new ToastConstructor()

  // 将实例挂载到div上 写入页面
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)

  // 通过Vue的原型注册toasts 所有实例共享
  Vue.prototype.$toasts = (msg, type) => {
    if (instance.dialog === false) { // 不允许实例多个覆盖内容，只有关闭后才再次渲染
      instance.dialog = true
      instance.message = msg
      let toastsType = type || 'default'
      instance.type = toastsType
    }
    //   setTimeout(() => {
    //     instance.visible = false
    //   }, 3000)
  }
}

export default Toast
